import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getQueryParams } from "../Util/HelperFunction";
import BrowseSearch from "./common/BrowseSearch";
import PlaybackSearch from "./common/PlaybackSearch";
import TrialBanner from "./common/TrialBanner";
import { getTailorFeedAction } from "../Redux/Action/browseAction";
import KeyStageMultiSelect from "./common/KeyStageMultiSelect";
const TopHeader = ({
  setSearchValue,
  searchValue,
  handleSelectClass,
  groupData,
  type,
  handleFocusActionState,
}) => {
  const dispatch = useDispatch();
  const Userstore = useSelector((state) => state?.authSlice.userData?.payload);
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  const tailorFeedData = useSelector(
    (state) => state?.browseSlice?.tailorFeedData
  );

  useEffect(() => {
    if (type === "Browse" && !tailorFeedData) {
      dispatch(getTailorFeedAction());
    }
  }, [type, tailorFeedData, dispatch]);

  const isTailorFeedEnabled = Boolean(
    tailorFeedData?.tailored_feed_enabled ??
    tailorFeedData?.tailor_feed_enabled ??
    tailorFeedData?.tailorFeedEnabled
  );

  const isTrial = schoolData?.isTrial && Userstore?.role === "School";
  const Location = useLocation();
  const queryParams = getQueryParams(Location?.search);
  const { selectedGroup } = queryParams;
  return (
    <>
      {type === "DetailPages" ? (
        <>
          {isTrial && (
            <div className="top-fix-sec">
              <div className="pt-2 d-flex">
                <div style={{ width: '240px', flexShrink: 0 }} className="d-none d-lg-block"></div>
                <div style={{ flexGrow: 1 }} className="pe-4 ps-3">
                  <TrialBanner />
                </div>
              </div>
            </div>
          )}
          <Row className="mt-2">
            <Col lg={10}></Col>
            <Col
              lg={2}
              className="d-flex align-items-center justify-content-end"
            >
              <div className="d-flex top-bar">
                
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <Container fluid>
          <div className="top-fix-sec">
            {isTrial && (
              <div className="pt-2 d-flex">
                <div style={{ width: '240px', flexShrink: 0 }} className="d-none d-lg-block"></div>
                <div style={{ flexGrow: 1 }} className="pe-4 ps-3">
                  <TrialBanner />
                </div>
              </div>
            )}
            <Row className={isTrial ? "mt-4" : "mt-2"}>
              <Col lg={3} md={0} sm={0}></Col>
              <Col lg={5} md={5} sm={5}>
                {type === "Browse" && (
                  <BrowseSearch
                    setSearchValue={setSearchValue}
                    searchValue={searchValue}
                    handleFocusActionState={handleFocusActionState}
                  />
                )}
                {type === "PlayBack" && (
                  <BrowseSearch
                    setSearchValue={setSearchValue}
                    searchValue={searchValue}
                    handleFocusActionState={handleFocusActionState}
                  />
                )}
                {type === "myLikes" && (
                  <PlaybackSearch
                    setSearchValue={setSearchValue}
                    handleFocusActionState={handleFocusActionState}
                  />
                )}
                {type === "collection" && (
                  <PlaybackSearch
                    setSearchValue={setSearchValue}
                    handleFocusActionState={handleFocusActionState}
                  />
                )}
              </Col>
              <Col lg={2} md={4}>
                {type === "Browse" && (
                  <KeyStageMultiSelect
                    selectedGroup={selectedGroup || ""}
                    onChange={handleSelectClass}
                    groupOptions={groupData}
                    isTailorFeedEnabled={isTailorFeedEnabled}
                    schoolGroup={Userstore?.schoolGroup}
                  />
                )}
              </Col>
              <Col
                lg={2}
                md={2}
                sm={4}
                className="d-flex align-items-center justify-content-end"
              >
                <div className="d-flex top-bar">
                  
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </>
  );
};

export default TopHeader;
